import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDDialogTitle, FDTitleText } from '@facet-wealth/design';

const uploadedAccountStatementsMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', { _component: () => FDDialogTitle }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDTitleText,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly);

export default uploadedAccountStatementsMetaOverrideSet;
